import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// project import
import useAuth from 'hooks/useAuth';

// types
import { GuardProps } from 'types/auth';
import Loader from '../../components/Loader';

// ==============================|| PAID USER GUARD ||============================== //
// This guard blocks free users from accessing certain routes and redirects them to billing page

const PaidUserGuard = ({ children }: GuardProps) => {
  const { isAuthenticated, user } = useAuth();
  const navigate = useNavigate();
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/login', { replace: true });
      return;
    }

    const isAdmin = user?.roles?.includes('Admin');
    const isPaidMember = user?.roles?.includes('Paid Member');
    const isFreeUser = !isAdmin && !isPaidMember;

    if (isFreeUser) {
      // Redirect free users to billing page
      navigate('/account-settings/billing', { replace: true });
    } else {
      setIsChecking(false);
    }
  }, [isAuthenticated, navigate, user]);

  if (isChecking) {
    return <Loader />;
  }

  return children;
};

export default PaidUserGuard;
